module.exports = __webpack_public_path__ + "static/img/M-1.80e154f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-1.png
// module id = Rnmp
// module chunks = 0